// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class EmailRecipient {
  readonly email: string;
  readonly name?: string;

  constructor(data: { [key: string]: any } = {}) {
    this.email = data.email === undefined ? '' : data.email;
    this.name = data.name;
  }

  static zero(): EmailRecipient {
    const zeroValues: ExcludeMethodsDeep<EmailRecipient> = {
      email: '',
    };
    return new EmailRecipient(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type EmailRecipientWireFormat = {
  email: string;
  name?: string;
};

type NewEmailRecipientProps = PartialDeep<EmailRecipient, { recurseIntoArrays: true }>;
export const NewEmailRecipient: (props: NewEmailRecipientProps) => EmailRecipient = (props) =>
  new EmailRecipient(props);

type NewEmailRecipientFromWireFormatProps = PartialDeep<
  EmailRecipientWireFormat,
  { recurseIntoArrays: true }
>;
export const NewEmailRecipientFromWireFormat: (
  props: NewEmailRecipientFromWireFormatProps,
) => EmailRecipient = (props) => new EmailRecipient(props);
